import { render, staticRenderFns } from "./idNormativa.vue?vue&type=template&id=1be3dca7&scoped=true"
import script from "./idNormativa.ts?vue&type=script&lang=ts&external"
export * from "./idNormativa.ts?vue&type=script&lang=ts&external"
import style0 from "./idNormativa.vue?vue&type=style&index=0&id=1be3dca7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3dca7",
  null
  
)

export default component.exports